import { render, staticRenderFns } from "./_CreateAction.vue?vue&type=template&id=0cbf94d0&scoped=true&"
import script from "./_CreateAction.vue?vue&type=script&lang=ts&"
export * from "./_CreateAction.vue?vue&type=script&lang=ts&"
import style0 from "./_CreateAction.vue?vue&type=style&index=0&id=0cbf94d0&lang=scss&scoped=true&"
import style1 from "./_CreateAction.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbf94d0",
  null
  
)

export default component.exports